var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var writeToStream = require('./writeToStream');
var EventEmitter = require('events');
function generate(packet, opts) {
  var stream = new Accumulator();
  writeToStream(packet, stream, opts);
  return stream.concat();
}
var Accumulator = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Accumulator, _EventEmitter);
  var _super = _createSuper(Accumulator);
  function Accumulator() {
    var _this;
    _classCallCheck(this, Accumulator);
    _this = _super.call(this);
    _this._array = new Array(20);
    _this._i = 0;
    return _this;
  }
  _createClass(Accumulator, [{
    key: "write",
    value: function write(chunk) {
      this._array[this._i++] = chunk;
      return true;
    }
  }, {
    key: "concat",
    value: function concat() {
      var length = 0;
      var lengths = new Array(this._array.length);
      var list = this._array;
      var pos = 0;
      var i;
      for (i = 0; i < list.length && list[i] !== undefined; i++) {
        if (typeof list[i] !== 'string') lengths[i] = list[i].length;else lengths[i] = Buffer.byteLength(list[i]);
        length += lengths[i];
      }
      var result = Buffer.allocUnsafe(length);
      for (i = 0; i < list.length && list[i] !== undefined; i++) {
        if (typeof list[i] !== 'string') {
          list[i].copy(result, pos);
          pos += lengths[i];
        } else {
          result.write(list[i], pos);
          pos += lengths[i];
        }
      }
      return result;
    }
  }]);
  return Accumulator;
}(EventEmitter);
module.exports = generate;